/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Stock_SourceInputs */



/**
* | output |
* | --- |
* | "Stock source" |
*
* @param {Promos_Stock_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_stock_source = /** @type {((inputs?: Promos_Stock_SourceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Stock_SourceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source du stock")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuente del stock")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fonte do estoque")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonte dello stock")
	return /** @type {LocalizedString} */ ("Stock source")
});